import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { useMe } from '../../hooks/queries'
import { startziel } from '../../lib/letzterChat'
import { useTexte } from '../../texte'

/**
 * Beim Öffnen der Anwendung: dorthin zurück, wo man war.
 *
 * Drei Fälle, und alle drei stehen hier:
 *
 * - **Zuletzt ein Chat** — der geht auf.
 * - **Zuletzt die Übersicht** — dann bleibt es die Übersicht. Wer die Liste
 *   offen gelassen hat, will sie wiedersehen.
 * - **Nichts gemerkt** — dann die Übersicht. Also beim ersten Start auf einem
 *   Gerät, nach dem Abmelden und dann, wenn die gemerkte Reise verschwunden
 *   ist.
 *
 * Zwischendurch stand hier ein vierter Fall: ohne Erinnerung den obersten
 * Eintrag der Liste aufmachen. Das war ein Pflaster, als die `StandWache` die
 * Erinnerung überschrieb (siehe `Shell`) — und ein schlechtes: es zeigt einen
 * Chat, den niemand zuletzt offen hatte, und verdeckt dabei genau den Zustand,
 * an dem man den Fehler erkannt hätte.
 *
 * Und das **einmal je Start**, nicht bei jedem Besuch der Übersicht. Sonst
 * wäre der Weg zur Liste versperrt: jedes „Zurück" fiele sofort wieder in den
 * Chat, aus dem man gerade gekommen ist. Die Marke steht deshalb im Modul und
 * nicht im Gerät -- sie gilt für diese Sitzung, nicht für die nächste.
 */
let verbraucht = false

/** Was rechts steht, solange kein Chat geöffnet ist. Am Telefon nie sichtbar. */
export function StartPane() {
  const texte = useTexte()
  const t = texte.rahmen.start
  const me = useMe()
  // Im Anfangswert wird nur gelesen, nicht verbraucht: React ruft ihn in der
  // Entwicklung zweimal auf.
  const [start] = useState(() => !verbraucht)
  const [ziel] = useState(() => (verbraucht ? null : startziel()))

  useEffect(() => {
    verbraucht = true
  }, [])

  // Kein `replace`: der Schritt bleibt in der Geschichte des Browsers stehen,
  // damit der Zurück-Knopf zur Liste führt und nicht aus der Anwendung heraus.
  if (start && ziel?.art === 'chat') return <Navigate to={ziel.pfad} />

  return (
    <div className="empty">
      <p className="empty__title">{texte.allgemein.name}</p>
      {me.data?.may_create_trips ? (
        <p>
          {t.waehleMitAnlegen}
          <br />
          {t.alsAutor}
        </p>
      ) : (
        <p>
          {t.waehle}
          <br />
          {t.alsLeser}
        </p>
      )}
    </div>
  )
}
